// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1MYiH","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2twvQ"};